<div>
  <div class="mb-[36px]">
    <nz-alert nzShowIcon [nzMessage]="'automation-gap-rule_html_gap_m_alert' | translate"></nz-alert>
  </div>
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "automation-gap-rule_html_gap_m" | translate }}</div>
    <div class="block-list">
      <span>
        {{ "automation-gap-rule_html_gap_m_1" | translate }}
      </span>
      <input class="w-[80px] ml-2" nz-input type="text" nzSize="large" [(ngModel)]="defaultMinStay" />
      <span>
        {{ "automation-gap-rule_html_gap_m_2" | translate }}
      </span>
    </div>
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "automation-gap-rule_html_scope" | translate }}</div>
    <div class="block-list">
      <!-- 渠道 -->
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_channel" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select
              class="w-full placeholder-dark"
              nzSize="large"
              nzMode="multiple"
              [(ngModel)]="channel"
              (ngModelChange)="onSelectChannels($event)"
              [nzPlaceHolder]="'word.all' | translate"
              [nzOptions]="listOfChannelOption"></nz-select>
          </div>
        </div>
      </div>
      <!-- 账号 -->
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_channel_account" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select
              class="w-full placeholder-dark"
              nzSize="large"
              nzMode="multiple"
              [(ngModel)]="account"
              [nzPlaceHolder]="'word.all' | translate"
              [nzOptions]="listOfAccountOption"></nz-select>
          </div>
        </div>
      </div>

      <!-- 房间 -->
      <widget-rule-form-item-house-picker
        [data]="$any(properties)"
        (onChange)="properties = $event"></widget-rule-form-item-house-picker>
    </div>
  </div>

  <!-- <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "automation-gap-rule_html_actions" | translate }}</div>
    <div class="block-list">
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          {{ "automation-gap-rule_html_adjust_minstay" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            {{ "automation-gap-rule_html_adjust_minstay_control" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="flex justify-end">
    <button class="mr-3" nz-button nzSize="large" (click)="onCancel()">{{ "word.cancel" | translate }}</button>
    <button nz-button nzSize="large" nzType="primary" (click)="onSave()">{{ "word.save" | translate }}</button>
  </div>
</div>
